export default {"src":"/_next/static/media/two_avatar_arrow_64.2f15c941.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};